import EventDTO from '../models/event';
import { OrderDTO } from '../models/order';
import config from '../config/config';

const getOrderOwnerReferralLink = (event: EventDTO, order: OrderDTO) => {
  if (order.owner_referral) {
    return `${config.baseDomain}/events/${event?.slug}?ref=${order.owner_referral.code}`;
  }
  return null;
};

export default getOrderOwnerReferralLink;
